import React from 'react'
import Icon from '../../Icon2/Icon'
import CircularLoaderV2 from '../../CircularLoaderV2'

const TableLoaderV2 = ({ tableWidth, tableHeight }) => {
    let height = tableHeight ? tableHeight + 'px' : '100%'
    return (
        <div
            className="Table__loader"
            data-test-id="cs-table-loader"
            style={{
                width: tableWidth + 'px',
                height: `calc(${height} - 11.175rem)`
            }}>
             <CircularLoaderV2 size="large" />
        </div>
    )
}

export default TableLoaderV2
